import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	selectFileToUploadDescription: {
		id: 'project-create-importer-upload-flow.common.file-dropzone.dropzone-content.select-file-to-upload-description',
		defaultMessage: 'Select a file to upload',
		description: 'Message shown to user to select file to upload',
	},
	dragAndDropDescription: {
		id: 'project-create-importer-upload-flow.common.file-dropzone.dropzone-content.drag-and-drop-description',
		defaultMessage: 'or drag and drop here',
		description: 'Message shown to user for dragging and dropping a file',
	},
	uploadingErrorMessage: {
		id: 'project-create-importer-upload-flow.common.file-dropzone.dropzone-content.uploading-error-message',
		defaultMessage: 'We couldn’t upload your file. Try again.',
		description: 'There was an issue uploading the file. Please try again.',
	},
	fileSizeTooLargeErrorMessage: {
		id: 'project-create-importer-upload-flow.common.file-dropzone.dropzone-content.file-size-too-large-error-message',
		defaultMessage:
			'This file exceeds the maximum file size of 500Mb. Upload a smaller file to proceed.',
		description: 'Error message shown when file size exceeds the limit',
	},
	unsupportedFileErrorMessage: {
		id: 'project-create-importer-upload-flow.common.file-dropzone.dropzone-content.unsupported-file-error-message',
		defaultMessage: 'This file is not supported. Try uploading a CSV file.',
		description: 'This file is not supported. Try uploading a CSV file.',
	},
});
